import script from "./ModelIframe.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModelIframe.vue?vue&type=script&setup=true&lang=ts"

import "./ModelIframe.vue?vue&type=style&index=0&id=3ca71baf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca71baf"]])

export default __exports__